<template>
  <v-dialog v-model="dialog" :max-width="options.width" persistent @keydown.esc="cancel()">
    <v-card>
      <v-card-title :class="options.color" class="white--text">
        {{ title }}
      </v-card-title>
      <v-card-text v-show="!!message" class="pt-5">{{ message }}</v-card-text>
      <v-divider></v-divider>
      <v-card-actions :class="$vuetify.breakpoint.xsOnly && 'flex-column-reverse'">
        <v-spacer></v-spacer>
        <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : ''"
            :large="$vuetify.breakpoint.xsOnly"
            :text="$vuetify.breakpoint.smAndUp"
            @click.native="cancel()"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
            v-if="options.agree"
            :block="$vuetify.breakpoint.xsOnly"
            :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : ''"
            :color="options.color"
            :large="$vuetify.breakpoint.xsOnly"
            @click.native="agree()"
        >
          {{ options.agree }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {});
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open;
 * }
 */
export default {
  name: 'ConfirmDialog',

  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: 'primary',
        agree: this.$t('yes'),
        cancel: this.$t('no'),
        width: 390,
      },
    };
  },
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign({
        color: 'primary',
        agree: this.$t('yes'),
        cancel: this.$t('no'),
        width: 390,
      }, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
  mounted() {
    this.$root.$confirm = this.open;
  }
};
</script>
